import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { palette, radius, shadow } from './designTokens';

const KpiCard = ({
  icon, label, value, accent = palette.brand, accentSoft = palette.brandSoft, delta, hint,
}) => {
  const positive = typeof delta === 'number' ? delta >= 0 : null;

  return (
    <Box
      sx={{
        position: 'relative',
        bgcolor: palette.surface,
        borderRadius: `${radius.md}px`,
        border: `1px solid ${palette.line}`,
        boxShadow: shadow.card,
        p: 2,
        // No lift on hover: a metric is not a button, and a card that rises
        // under the cursor promises a click that never comes.
        transition: 'border-color 0.18s ease',
        '&:hover': { borderColor: palette.hint },
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ position: 'relative' }}>
        <Box>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: palette.muted, letterSpacing: '0.02em' }}>
            {label}
          </Typography>
          <Typography sx={{ fontSize: 30, fontWeight: 800, color: palette.ink, mt: 0.25, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
            {value}
          </Typography>
          {(hint || delta != null) && (
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
              {delta != null && (
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={0.25}
                  sx={{
                    px: 0.75, py: 0.1, borderRadius: '999px',
                    bgcolor: positive ? palette.successSoft : palette.dangerSoft,
                    color: positive ? '#065F46' : '#9F1239',
                  }}
                >
                  {positive
                    ? <TrendingUpIcon sx={{ fontSize: 12 }} />
                    : <TrendingDownIcon sx={{ fontSize: 12 }} />
                  }
                  <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
                    {Math.abs(delta).toFixed(1)}%
                  </Typography>
                </Stack>
              )}
              {hint && (
                <Typography
                  title={hint}
                  sx={{
                    fontSize: 11,
                    lineHeight: 1.45,
                    color: palette.muted,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {hint}
                </Typography>
              )}
            </Stack>
          )}
        </Box>
        {/* A quiet chip, not a slab. Four saturated tiles in a row compete with the
            four numbers they belong to — and the numbers are the point. The
            accent tints the ground and colours the glyph instead of filling
            the square, so the row reads as one set. */}
        <Box
          sx={{
            width: 38, height: 38,
            borderRadius: `${radius.sm}px`,
            bgcolor: accentSoft,
            color: accent,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
            '& svg': { fontSize: 19 },
          }}
        >
          {icon}
        </Box>
      </Stack>
    </Box>
  );
};

export default KpiCard;
